import classNames from 'classnames/bind';
import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from 'tuui';
import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useNodeWindowOverflow } from '../../hooks/useNodeWindowOverflow';
import styles from './FieldSortingOption.module.scss';

const sortingOrder = [SORTING_ORDER_TYPES.ASCENDANT, SORTING_ORDER_TYPES.DESCENDANT];
const classNameBuilder = classNames.bind(styles);

const requiredWidth = 320;

export const FieldSortingOption = ({ value, label, currentSortField, currentOrderField, onSort }) => {
    const { containerRef, overflowWidth } = useNodeWindowOverflow({
        requiredWidth,
    });

    return (
        <div
            key={value}
            className={classNameBuilder('sorting-field-wrapper', {
                active: currentSortField === value,
            })}
            ref={containerRef}
        >
            <div className={classNameBuilder('sorting-field')}>
                <span className={classNameBuilder('sorting-field-label')}>{label}</span>
                <span className={classNameBuilder('sorting-dropdown-icon')}>
                    {true ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
                </span>
            </div>
            <div
                className={classNameBuilder('sorting-order-dropdown')}
                style={overflowWidth ? { right: '100%', left: 'unset' } : {}}
            >
                {sortingOrder.map(order => (
                    <div
                        key={order}
                        className={classNameBuilder('sorting-order', {
                            active: currentSortField === value && currentOrderField === order,
                        })}
                        onClick={() => {
                            if (currentSortField === value && currentOrderField === order) {
                                return;
                            }
                            onSort([{ field: value, order }]);
                        }}
                    >
                        <FormattedMessage id={`app.breadcrumbs.${value}.${order}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};
